import React from "react";
import { List, NavBar, Radio } from 'antd-mobile'

import { 
    BodyView,
    ListView
} from "../factory/ViewUtil";
import { LanguageList, LanguageSymbol, SetLanguage } from "./LanduagesManager";

const ItemView = React.memo(({data, onClick}) => {
    return (
        <List.Item
            onClick={onClick}
            arrowIcon={false} 
            className='cellCardBorder'
            style={{fontSize : '15px'}}
            extra={<Radio value={data.symbol} onClick={()=>{}}></Radio>}>
             {data.title}
        </List.Item>
    )
})

const LanguagesViewController = ({goback, t}) => {
    
    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>{t('languages')}</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <Radio.Group value={LanguageSymbol()}>
                    <ListView>
                        {
                            LanguageList().map((item, index) => (
                                <ItemView key={index} data={item} onClick={()=>{SetLanguage(item.symbol);goback();}}/>
                            ))
                        }
                    </ListView>
                </Radio.Group>
            </BodyView>
        </>
    );
}
export default React.memo(LanguagesViewController)